import './page.css';
import contact from '../data/contact.json';
import achievements from '../data/achievements.json';



function AchievementsCard(achievement) {
	const title = achievement.title;
	const summary = achievement.summary;
	const link = achievement.link;
	const photo = achievement.photo;

	function HoverButton(e){
		e.target.style.background ="rgb(255, 169, 255)"
		e.target.style.color = "black"
		e.target.style.cursor = "pointer";
	}

	function LeaveButton(e){
		e.target.style.background = '#3f3f3f'
		e.target.style.color = "white"
	}

	return (
		<div className='card card-smaller'>
			<a href={`./images/${photo}`} target="_blank" title="Make image larger in new tab">
				<img src = {`./images/${photo}`} className='img'></img>
			</a>
			<div className='card-info card-column'>
				<div className='card-title-link card-row'>
					<p>{title}</p>
					{link ? 
					<a href={link} target='_blank'>
						<button onMouseLeave = {LeaveButton} onMouseOver = {HoverButton} className='link'>Direct Link</button>
					</a>
					: null
					}
				</div>
				<p>{summary}</p>
			</div>

		</div>
	)
}

export default function Home() {

	return(
		<div className = "pads">
		<h1 className = "headline">Jacob Hershberger</h1>
		<h2 className = "headline">Web and Mobile Dev | 3D Asset and Animation Game Dev</h2>
		
		<div className = "card-row contact">
			<a href = {`mailto:${contact.email}`} target = "_blank"><img src = "./images/icons/email.svg" width = "50px"/></a>
			<a href = {contact.github} target = "_blank"><img src = "./images/icons/github.svg" width = "50px"/></a>
			<a href = {contact.linkedin} target = "_blank"><img src = "./images/icons/linkedin.svg" width = "50px"/></a>
			<a href = {contact.itch} target = "_blank"><img src = "./images/icons/itch-io.svg" width = "50px"/></a>
		</div>

		<h1 className="headline">Memorable Achievements  - {achievements.length} Items:</h1>

		<div className='cards card-column'>
		{
			achievements.map(achievement => (
				<AchievementsCard {...achievement}/>
			))
		}
		</div>
		</div>
	)
}